"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoboLogRebalanced = void 0;
var Card_1 = require("../../Card");
var Tags_1 = require("../../Tags");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var Size_1 = require("../../render/Size");
var PhoboLogRebalanced = (function (_super) {
    __extends(PhoboLogRebalanced, _super);
    function PhoboLogRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.PHOBOLOG_REBALANCED,
            tags: [Tags_1.Tags.SPACE],
            startingMegaCredits: 30,
            initialActionText: 'Draw 2 cards with a space tag',
            metadata: {
                cardNumber: 'R09',
                description: 'You start with 8 titanium and 30 M€. As your first action, reveal cards from the deck until you have revealed 2 cards with a space tag. Take them into hand and discard the rest.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br;
                    b.megacredits(30).nbsp.titanium(8).digit.cards(2).secondaryTag(Tags_1.Tags.SPACE);
                    b.corpBox('effect', function (ce) {
                        ce.effect('Your titanium resources are each worth 1 M€ extra.', function (eb) {
                            eb.titanium(1).startEffect.plus(Size_1.Size.SMALL).megacredits(1);
                        });
                    });
                }),
            },
        }) || this;
    }
    PhoboLogRebalanced.prototype.initialAction = function (player) {
        player.drawCard(2, { tag: Tags_1.Tags.SPACE });
        return undefined;
    };
    PhoboLogRebalanced.prototype.play = function (player) {
        player.titanium = 8;
        player.increaseTitaniumValue();
        return undefined;
    };
    return PhoboLogRebalanced;
}(Card_1.Card));
exports.PhoboLogRebalanced = PhoboLogRebalanced;
//# sourceMappingURL=PhoboLogRebalanced.js.map